import React, { useEffect, useContext } from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import PeopleIcon from '@material-ui/icons/People';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import ListAltIcon from '@material-ui/icons/ListAlt';

import usePlans from "../../../hooks/usePlans";
import { AuthContext } from "../../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 20,
    boxShadow: '0 12px 40px rgba(102, 126, 234, 0.15)',
    border: '1px solid rgba(102, 126, 234, 0.1)',
    overflow: 'hidden',
  },
  cardHeader: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    padding: theme.spacing(3, 3, 2),
    textAlign: 'center',
  },
  planName: {
    fontSize: '1.6rem',
    fontWeight: 700,
    color: '#fff',
    letterSpacing: '0.5px',
  },
  priceContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    padding: theme.spacing(4, 0, 2),
  },
  price: {
    fontSize: '3rem',
    fontWeight: 800,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
  },
  period: {
    fontSize: '1.1rem',
    color: '#8898aa',
    marginLeft: 6,
    fontWeight: 500,
  },
  featureRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: theme.spacing(1.2, 0),
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  featureIcon: {
    color: '#667eea',
    fontSize: '1.2rem',
  },
  featureText: {
    fontSize: '1rem',
    color: '#525f7f',
    fontWeight: 500,
  },
  continueBtn: {
    borderRadius: 12,
    padding: '14px 0',
    fontWeight: 700,
    fontSize: '1rem',
    textTransform: 'none',
    letterSpacing: '0.5px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    boxShadow: '0 4px 14px rgba(102, 126, 234, 0.4)',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0 6px 20px rgba(102, 126, 234, 0.5)',
      transform: 'translateY(-1px)',
    },
  },
  cardActions: {
    padding: theme.spacing(2, 3, 3),
  },
}));

export default function Pricing(props) {
  const { setFieldValue, setActiveStep, activeStep } = props;
  const classes = useStyles();
  const [storagePlans, setStoragePlans] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const { user } = useContext(AuthContext);
  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      await loadPlans();
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadPlans = async () => {
    setLoading(true);
    try {
      const companyId = user.companyId;
      const _planList = await getPlanCompany(undefined, companyId);
      const planList = _planList.plan;
      const plans = [];
      plans.push({
        title: planList.name,
        planId: planList.id,
        price: planList.amount,
        description: [
          { text: `${planList.users} Usuários`, icon: <PeopleIcon className={classes.featureIcon} /> },
          { text: `${planList.connections} Conexões`, icon: <DeviceHubIcon className={classes.featureIcon} /> },
          { text: `${planList.queues} Filas`, icon: <ListAltIcon className={classes.featureIcon} /> },
        ],
        users: planList.users,
        connections: planList.connections,
        queues: planList.queues,
      });
      setStoragePlans(plans);
    } catch (e) {
      // toast.error("Não foi possível carregar a lista de registros");
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Grid container spacing={3} justifyContent="center">
        {storagePlans?.map((tier) => (
          <Grid item key={tier.title} xs={12} sm={10} md={8}>
            <Card className={classes.card}>
              <CardHeader
                title={tier.title}
                titleTypographyProps={{ align: 'center', className: classes.planName }}
                className={classes.cardHeader}
              />
              <CardContent style={{ padding: '0 24px' }}>
                <div className={classes.priceContainer}>
                  <Typography component="span" className={classes.price}>
                    R${Number(tier.price).toLocaleString('pt-br', { minimumFractionDigits: 2 })}
                  </Typography>
                  <Typography component="span" className={classes.period}>
                    /mês
                  </Typography>
                </div>
                <div style={{ padding: '8px 0 16px' }}>
                  {tier.description.map((line, idx) => (
                    <div className={classes.featureRow} key={idx}>
                      {line.icon}
                      <Typography className={classes.featureText}>{line.text}</Typography>
                    </div>
                  ))}
                </div>
              </CardContent>
              <CardActions className={classes.cardActions}>
                <Button
                  fullWidth
                  variant="contained"
                  className={classes.continueBtn}
                  onClick={() => {
                    setFieldValue("plan", JSON.stringify(tier));
                    setActiveStep(activeStep + 1);
                  }}
                >
                  CONTINUAR
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  );
}